import React from 'react';
import Divider from '@material-ui/core/Divider';
import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import mainMenuLinks from './mainMenuLinks';
import useAppContext from '../../../hooks/context/useAppContext';
import { useIntl } from 'react-intl';

const Wrapper = styled.div`
  width: 100%;
`;

const PaddedSection = styled.div`
  padding: 0 24px;
`;

const MainMenuHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: auto;

  span {
    color: #363738;
    display: flex;
    flex-direction: row;
  }
  span:first-child {
    flex-shrink: 0;
    flex-grow: 0;
    width: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  span:last-child {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    justify-content: left;
  }
`;

const MainMenuList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin: 5px 0;

  a {
    text-decoration: none;
    color: #363738;
    padding: 6px 12px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
      border-radius: 0px;
    }
  }
`;
const MainMenuContent = () => {
  const { getUser } = useAppContext();
  const user = getUser();
  const role = user.role;
  const location = useLocation();
  const intl = useIntl();

  const activeLinks = mainMenuLinks[role];

  const isLinkActive = (link) =>
    link.exact ? location.pathname === link.path : location.pathname.startsWith(link.path);

  return (
    <Wrapper>
      <PaddedSection>
        <MainMenuHeader>
          <span>{user.organizationLogo && <img src={user.organizationLogo} style={{ width: '30px' }} alt="" />}</span>
          <span>{user.organization}</span>
        </MainMenuHeader>
      </PaddedSection>
      <Divider />
      <PaddedSection>
        <nav aria-label={intl.formatMessage({ id: 'app.menu.aria.mainNav' })}>
          <MainMenuList>
            {activeLinks?.map((link, index) => (
              <NavLink
                key={index}
                to={link.path}
                exact={link.exact}
                onClick={link.action()}
                aria-current={isLinkActive(link) ? 'page' : undefined}>
                {link.icon || null}
                {link.label}
              </NavLink>
            ))}
          </MainMenuList>
        </nav>
      </PaddedSection>
    </Wrapper>
  );
};

MainMenuContent.propTypes = {};

export default MainMenuContent;
